import { Component } from '@angular/core';
import { NetworkMonitorService } from './services/network-monitor.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {
  constructor(private readonly networkMonitorService: NetworkMonitorService) {
    this.networkMonitorService.refreshStatus().catch(() => {});
  }
}
